// material-ui
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import FormHelperText from '@mui/material/FormHelperText';
import Grid from '@mui/material/Grid';

import TextField from '@mui/material/TextField';

// third party
import * as Yup from 'yup';
import { Formik } from 'formik';

// project imports
import AnimateButton from 'ui-component/extended/AnimateButton';

import useScriptRef from 'hooks/useScriptRef';
import { dispatch } from 'store';
import { openSnackbar } from 'store/slices/snackbar';
import useAuth from 'hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import FormControl from '@mui/material/FormControl';
import SpinnerLoader from 'ui-component/Spinner';
// ===========================|| FIREBASE - REGISTER ||=========================== //

const ForgotPasswordOtpVerification = ({
    currentStepData,
    handleStepChange,
    registerObj,
    ...others
}: {
    currentStepData: any;
    handleStepChange: Function;
    registerObj: any;
    [key: string]: any;
}) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const scriptedRef = useScriptRef();
    const { setForgotPassword } = useAuth();

    return (
        <>
            {/* <Grid container direction="column" justifyContent="center" spacing={2}>
                <Grid item xs={12} container alignItems="center" justifyContent="center">
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="subtitle1">Sign up with {loginMode === phone ? 'mobile number' : 'email address'}</Typography>
                    </Box>
                </Grid>
            </Grid> */}

            <Formik
                initialValues={{
                    phoneOtp: '',
                    submit: null
                }}
                validationSchema={Yup.object().shape({
                    phoneOtp: Yup.string().max(6).required('Otp  is required')
                })}
                onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
                    try {
                        const formData = registerObj['forgot'].data;
                        const phoneWithCode = `${formData.countrycode + formData.phone}`;
                        const result = await setForgotPassword(
                            phoneWithCode,
                            formData.email,
                            formData.password,
                            formData.passwordConfirmation,
                            formData.token,
                            values.phoneOtp
                        );

                        setStatus({ success: true });
                        setSubmitting(false);
                        handleStepChange('forgotSuccess');

                        // setTimeout(() => {
                        //     navigate('/', { replace: true });
                        // }, 1500);
                    } catch (err: any) {
                        setStatus({ success: false });
                        setErrors({ submit: err.response.data.message });
                        setSubmitting(false);
                    }
                }}
            >
                {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
                    <form noValidate onSubmit={handleSubmit} {...others}>
                        <FormControl
                            fullWidth
                            error={Boolean(touched.phoneOtp && errors.phoneOtp)}
                            sx={{ ...theme.typography.customInput }}
                        >
                            <TextField
                                inputProps={{}}
                                label="Enter Otp"
                                name="phoneOtp"
                                type="text"
                                value={values.phoneOtp}
                                onBlur={handleBlur}
                                onChange={handleChange}
                            />
                            {/* {touched.phoneOtp && errors.phoneOtp && (
                                    <FormHelperText error id="standard-weight-helper-text--register">
                                        {errors.phoneOtp}
                                    </FormHelperText>
                                )} */}
                        </FormControl>

                        {errors.submit && (
                            <Box sx={{ mt: 0 }}>
                                <FormHelperText className="909090" error>
                                    {errors.submit}
                                </FormHelperText>
                            </Box>
                        )}

                        <Box
                            sx={{ mt: 2, display: 'flex', flexDirection: 'row', gap: '15px', mb: '15px', justifyContent: 'space-between' }}
                        >
                            <Button
                                disableElevation
                                disabled={isSubmitting}
                                fullWidth
                                size="large"
                                type="submit"
                                variant="contained"
                                color="secondary"
                                sx={{
                                    backgroundColor: theme.palette.secondary.main,
                                    color: '#121212',
                                    boxShadow: 'inherit',
                                    mb: '10px',
                                    fontSize: '16px',
                                    fontWeight: '700',
                                    width: '100%',
                                    '&:hover': {
                                        backgroundColor: theme.palette.secondary.main,
                                        color: '#212121',
                                        boxShadow: 'inherit'
                                    }
                                }}
                            >
                                Verify Otp{isSubmitting && <SpinnerLoader />}
                            </Button>

                            <Button
                                disableElevation
                                disabled={isSubmitting}
                                fullWidth
                                size="large"
                                type="submit"
                                variant="contained"
                                color="secondary"
                                sx={{
                                    background: 'none !important',
                                    borderWidth: '1px',
                                    borderStyle: 'solid',
                                    color: theme.palette.secondary.main,
                                    // borderColor: 'theme.palette.secondary.main',
                                    border: '1px solid ',
                                    borderColor: theme.palette.secondary.main,

                                    boxShadow: 'inherit',
                                    width: '100%',
                                    mb: '10px',
                                    display: 'none',
                                    '&:hover': {
                                        background: 'none !important',
                                        borderWidth: '1px',
                                        borderStyle: 'solid',
                                        color: theme.palette.secondary.main,
                                        borderColor: theme.palette.secondary.main,
                                        boxShadow: 'inherit'
                                    }
                                }}
                            >
                                Resend Otp{isSubmitting && <SpinnerLoader />}
                            </Button>
                        </Box>
                    </form>
                )}
            </Formik>
        </>
    );
};

export default ForgotPasswordOtpVerification;
